import { lazy } from "react";
import { Mail } from "lucide-react";
import type { AdminPlugin } from "@/plugins/types";

const Submissions = lazy(() => import("@/pages/admin/Submissions"));

const submissionsPlugin: AdminPlugin = {
  id: "submissions",
  label: "Submissions",
  icon: Mail,
  route: "submissions",
  component: Submissions,
  menuOrder: 1,
};

export default submissionsPlugin;
